const routes = [
    {
        path: '/certificacoes',
        meta: {
            roles: ['ROLE_FEATURE_CERTIFICACAO']
        },
        component: () => import('@/views/DefaultRouterView'),
        children: [
            {
                path: '',
                name: 'Certificacao',
                meta: {
                    roles: ['ROLE_FEATURE_CERTIFICACAO']
                },
                component: () =>
                    import(
                        '@/modules/certification/views/pages/main/MainPage.vue'
                    )
            },
            {
                path: 'certificacao/cadastrar',
                name: 'CadastrarCertificacao',
                meta: {
                    roles: ['ROLE_FEATURE_CERTIFICACAO']
                },
                component: () =>
                    import(
                        '@/modules/certification/views/pages/create/CreatePage.vue'
                    )
            },
            {
                path: 'certificacao/analise/:idCertificacao',
                name: 'VisualizarAnalise',
                meta: {
                    roles: ['ROLE_FEATURE_CERTIFICACAO']
                },
                component: () =>
                    import(
                        '@/modules/certification/views/pages/detail/DetailPage.vue'
                    )
            },
            {
                path: 'certificacao/visualizar-resultados-diagnosticos/:idCertificacaoTerritorio/:idCertificacaoTerritorioTipo',
                name: 'DetalhamentoResultadosDiagnosticos',
                meta: {
                    roles: ['ROLE_FEATURE_CERTIFICACAO']
                },
                component: () =>
                    import(
                        '@/modules/certification/views/pages/analysis-detail/AnalysisDetailPage.vue'
                    )
            }
        ]
    }
];

export default routes;
